import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { useKeyboardInset } from '@lidea/shared/util/core';
import { close, eyeOffOutline } from 'ionicons/icons';
import classNames from 'classnames';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './modal-page.module.css';

/* eslint-disable-next-line */
export interface ModalPageProps {
  children?: React.ReactNode;
  title: string;
  onClose: () => void;
  eyeOff?: boolean;
  isHidden?: boolean;
  setIsHidden?: (value: boolean) => void;
  headerExtension?: JSX.Element;
  toolbarStart?: React.ReactNode;
  toolbarEnd?: React.ReactNode;
  hideCloseButton?: boolean;
  centerTitle?: boolean;
  keyboardFriendly?: boolean;
}

export function ModalPage(props: ModalPageProps) {
  const { t } = useTranslation(['common'], { useSuspense: false });
  const contentRef = useRef<HTMLIonContentElement>(null);

  useKeyboardInset(contentRef, props.keyboardFriendly ?? false);

  const handleButtonClick = () => {
    props.setIsHidden && props.setIsHidden(!props.isHidden);
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar
          className={classNames({
            [styles.toolbarCentered]: props.centerTitle,
          })}
        >
          {props.toolbarStart ? (
            <IonButtons slot="start">{props.toolbarStart}</IonButtons>
          ) : null}
          <IonTitle
            className={classNames({ [styles.centerTitle]: props.centerTitle })}
            style={props.centerTitle ? undefined : { fontSize: '18px' }}
          >
            {props.title}
          </IonTitle>
          <IonButtons slot="end">
            {props.eyeOff && (
              <IonTitle
                className={styles.buttonSat}
                onClick={handleButtonClick}
              >
                {t('common:visualize')}
              </IonTitle>
            )}
            {props.toolbarEnd}
            {!props.hideCloseButton ? (
              <IonButton onClick={props.onClose}>
                <IonIcon
                  aria-label="close modal"
                  icon={close}
                  slot="icon-only"
                ></IonIcon>
              </IonButton>
            ) : null}
          </IonButtons>
        </IonToolbar>
        {props.headerExtension}
      </IonHeader>
      <IonContent
        ref={contentRef}
        className={classNames(styles.content, {
          [styles.contentKeyboardFriendly]: props.keyboardFriendly,
        })}
      >
        {props.children}
      </IonContent>
    </IonPage>
  );
}
export default ModalPage;
